import {normalizeRead,filterArtworkRows} from './artworkCreatedModel.js'

// Cursors contain no cached rows. Every navigation rereads current authority.
export function normalizeArtworkPage(data) {
  normalizeRead(data)
  const page=data.pagination
  if(data.inventoryComplete!==false||!page||page.pageSize!==100||page.countsScope!=='page'||page.snapshotScope!=='per_page_current'||typeof page.hasMore!=='boolean'
    ||(page.hasMore?(typeof page.nextCursor!=='string'||!page.nextCursor||page.nextCursor.length>2048):page.nextCursor!==null)) {
    throw Error('The saved artwork page is incomplete. Refresh the first page; inventory totals are unknown.')
  }
  return data
}
export function initialArtworkPage(scope) {return {scope,cursors:[null],index:0}}
export function scopedArtworkPage(state,scope) {return state?.scope===scope?state:initialArtworkPage(scope)}
export function moveArtworkPage(state,direction,pagination) {
  if(direction==='previous')return state.index>0?{...state,index:state.index-1}:state
  if(direction!=='next'||pagination?.hasMore!==true||typeof pagination.nextCursor!=='string'||!pagination.nextCursor)return state
  if(state.cursors.slice(0,state.index+1).includes(pagination.nextCursor))throw Error('Saved artwork paging repeated a cursor. Refresh the first page.')
  return {...state,cursors:[...state.cursors.slice(0,state.index+1),pagination.nextCursor],index:state.index+1}
}

export function hasArtworkFilters(filters={}) {return Boolean(filters.q?.trim()||filters.assigned?.trim()||filters.actor?.trim()||(filters.status&&filters.status!=='all'))}
export function shouldContinueArtworkSearch(data,filters) {return hasArtworkFilters(filters)&&filterArtworkRows(data.rows,filters).length===0&&data.pagination.hasMore}
export async function artworkQueryKey(filterKey) {
  const bytes=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(filterKey))
  return Array.from(new Uint8Array(bytes),value=>value.toString(16).padStart(2,'0')).join('')
}
